import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import ChatList from "../pages/chatlist/ChatList";
import { io } from "socket.io-client";
import { SIGNALR_URL, SOCKET_URL } from "../configs/api";
// import { userList } from "../services";
import * as chatService from "../services/chatService";
import * as signalR from "@microsoft/signalr";
import { getSignalRConnection } from "../SignalRConnection";
import { SocketContext } from "../services/socketContext";
import { v4 as uuidv4 } from 'uuid';
import VoiceCalling from "../pages/calling/VoiceCalling";
import { useCall } from "../services/callProviderContext";
import Draggable from "react-draggable";

const SignalRContext = createContext({})
const UsersDataContext = createContext();
const ChatListDataContext = createContext();
const GroupDataContext = createContext();

export default function Baselayout() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));

  const draggableRef = useRef(null);
  const {incomingCall} = useCall();
  const [connection] = useState(() => getSignalRConnection(loginData?.id));
  const {socket} = useContext(SocketContext);
  const location = useLocation();

  const [usersData, setUsersData] = useState([]);
  const [activeGroups, setActiveGroups] = useState([]);
  const [activeChats, setActiveChats] = useState([]);
  const [chatListItem, setChatListItem] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);  
  const [callingFlag, setCallingFlag] = useState(false);
  const [currCallUser, setCurrCallUser] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const isChatRoot = location.pathname === '/chat';
  // const [connection, setConnection] = useState(null);

  {/* ---------------Signal-R-diconnect----------------- */ }
  useEffect(() => {
    if (!connection) return;
  
    const handleUserList = (users) => {
      const validUsers = users.filter((user) => user !== null);
      setOnlineUsers(validUsers);
    }; 
  
    const handleUserConnected = (user) => {
      setOnlineUsers((prevUsers) =>
        prevUsers.includes(user) ? prevUsers : [...prevUsers, user]
      );
    };
  
    const handleUserDisconnected = (user) => {
      setOnlineUsers((prevUsers) => prevUsers.filter((u) => u !== user.key));
    };
  
    connection.on("OnConnectedUsersList", handleUserList);
    connection.on("OnConnectedUser", handleUserConnected);
    connection.on("OnDisconnectedUser", handleUserDisconnected);
  
    return () => {
      if (connection) {
        connection.off("OnConnectedUsersList", handleUserList);
        connection.off("OnConnectedUser", handleUserConnected);
        connection.off("OnDisconnectedUser", handleUserDisconnected);
  
        connection.stop().then(() => console.log("SignalR Connection Stopped"));
      }
    };
  }, [connection, loginData?.id]);

  /*socket*/
    useEffect(()=>{
    if (!socket) return;
    
    socket.emit('register', 
      {
      username: loginData.userName, 
      fcmToken: null, 
      uuid: uuidv4(),
      }
    );

  },[socket])
  

  const allUserList = async () => {
    const id = loginData?.userTypeId === 6 && loginData?.adminId !== 0 ? loginData?.adminId : loginData?.id;
    const data = { id }
    await chatService.userList(data)
      .then(async (response) => {
        setUsersData(response);
      })
      .catch((error) => {
        console.log("Error fetching user list", error);
      });
  };

  const activeGroupList = async () => {
    await chatService.getActiveGroups(loginData.id)
      .then(async (response) => {
        setActiveGroups(response);
      })
      .catch((error) => {
        console.log("Error fetching groups list", error);
      });
  };

  const activeChatList = async () => {
    const data = { id: loginData?.id };
    await chatService
      .getActiveChats(data)
      .then(async (response) => {
        setActiveChats(response);
      })
      .catch((error) => {
        console.log("Error fetching user list", error);
      });
  };

  useEffect(() => {
    allUserList();
    activeGroupList();
    activeChatList();
  }, []);

    const closeModal = () => {
    setCallingFlag(false)
  };

  /*-- size is less than 768---*/
  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth < 768;
      setIsMobile(isNowMobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <SignalRContext.Provider value={[connection, onlineUsers]}>
        <UsersDataContext.Provider value={usersData}>
          <ChatListDataContext.Provider value={{ chatListItem, setChatListItem, activeChats, setActiveChats, allUserList, activeChatList, callingFlag, setCallingFlag, currCallUser, setCurrCallUser }}>
            <GroupDataContext.Provider value={[activeGroups, setActiveGroups, activeGroupList]}>
              {(incomingCall || callingFlag) && (
                <Draggable nodeRef={draggableRef} handle=".modal-header">
                  <div ref={draggableRef} className="calling-modal-overlay">
                    <VoiceCalling
                      user={currCallUser}
                      setCallingFlag={setCallingFlag}
                      closeModal={closeModal}
                    />
                  </div>
                </Draggable>
              )}
              <div className="app desktop">
                <div className="row app-one">
                  <div id="mob" className="col-12 col-sm-4 col-md-3 col-lg-3 side mobileviewonly">
                    <ChatList />
                  </div>
                  {/* Only show Outlet if NOT mobile or not on root /chat */}
                  {(!isMobile || !isChatRoot) && (
                    <div className="col-12 col-sm-8 col-md-9 col-lg-9 conversation desktopviewonly">
                      <Outlet />
                    </div>
                  )}
                </div>
              </div>
              <div className="mobile">
                <div className="notsupport">
                  Screen Resolution Does Not Support
                </div>
              </div>
            </GroupDataContext.Provider>
          </ChatListDataContext.Provider>
        </UsersDataContext.Provider>
      </SignalRContext.Provider>
    </>
  );
}
export { SignalRContext, UsersDataContext, ChatListDataContext, GroupDataContext };
